import React, { Component } from 'react';

import {
    withRouter
} from 'react-router-dom';

import {
    Page,
    Text,
    Card,
    TextField,
    // OptionList,
    Button,
    // ProgressBar,
    BlockStack,
    Select,
    // Checkbox,
    Tooltip,
    Banner,
    Badge,
    Icon,
    // Modal,
    Spinner,
    // Tabs,
    OptionList,
    Tabs,
    // List,

} from '@shopify/polaris';
import {
    CancelMajor,
    // ChevronDownMinor,
    CircleAlertMajor,
    EmailMajor,
} from '@shopify/polaris-icons';
import './index.css';
import {
    reqUpdateLanguage,
    reqGetNotification,
    reqSetNotification,
    reqGetAccount,
    reqGetUsageRecordList,
    reqSaveSwitchState,
    reqSetReCountStatus,
    reqUpdExcessLimit,

} from '../../../api';
import { connect } from 'react-redux'
import { setPageData } from '../../../redux/actions/getAppPageData';
import { changeLanguageInfo, setLangState, setSaveSwitchData, setScrollHiddenState } from '../../../redux/actions/getAppPublicData';
import Switch from "react-switch";
import FunctionIntegration from '../FunctionIntegration/indexClass';
import SiteVerify from '../SiteVerify/indexClass';

// 翻译
import Language from '../../../i18n/Language';
import cloneDeep from 'lodash-es/cloneDeep';
import SkeltonLoading from '../../../components/SkeltonLoading';
import utils from '../../../utils/utils';
import { store } from '../../../redux/store';
import ImageAddOnesTable from './components/ImageAddOnesTable';
import SloutionExpert from '../SolutionExpert/indexClass';
import CheckOutIcon from '../../../assets/CheckOutIcon';
import SaveBarTop from '../../../components/SaveBarTop';
import FooterTrustHelp from '../../../components/FooterTrustHelp';
import { showNewMessage } from '@intercom/messenger-js-sdk';
const t = Language;

class Settings extends Component {
    state = {
        loadingPage: true,
        selected: 'Account',
        //免费图片额度
        ImageFreeQuota: 150,
        imagesProportion: 0,
        imagesAll: 0,
        imagesUse: 0,
        points_gift_all: 0,
        points_gift_use: 0,
        points_paid_all: 0,
        points_paid_use: 0,
        product_use: 0,
        product_all: 0,
        OnPagefreeQuota: 50,
        ap_login_url: '',
        short_url: '',
        Language: 'en',

        saveDisabled: [true, true, true],  // 保存按钮状态
        saveLoading: [false, false, false],  // 保存按钮loading
        eamilUser: '',
        eamilBro: '',
        broChecked: 0,
        exchangeChecked: 0,
        frequency: 1,
        loadingSwitch: false,
        reset_quota: '',
        NotificationData: {},
        emailError: '',
        backlinkError: '',
        NotOpenBacklink: false,
        exceedUse: 0,
        exceedAll: 0,
        addoneList: [], // 账单列表
        addLoading: true,
        overState: false, // 是否开启自动增量
        loadingSwitchOver: true,
        is_capped: false, // 是否显示增量设置
        level: 1,
        isRemoveState: false,
        removeLoading: true,
        selectUSD: '100 USD',
        selectCap: 100,
        originCap: 100,
        capState: false,
        capLoading: false,
        isLimitMax: false,

        iscacheLoading: true, // 缓存loading
        domain: '',
        setTabKey: 0,
        isComboUser: false,     // 是否组合套餐用户
        isShowCwAdverSetting: false,

        imagesPro: 0,          // 进度条
        product_pro: 0,
        points_gift_pro: 0,
        points_paid_pro: 0,
        overchargeError: "",        // 超额错误提示

        isOneTrial: false,
        isShowOverchargeTip: true,
        isShowSaveBar: false,   // 是否显示savebar
        saveBtnLoading: false,
        isApplicable: false,        // 是否可超额
        overchargeUse: 0,
        overchargeAll: 0,
        ppid: 1,                // 版本id
        c_pricing: 0,
        uid: -1,
        interSelect: 0,
        AppList: [
            {
                id: 1,
                title: "SEOAnt ‑ 404 Link Redirect",
                desc: "Automatically fix broken links and perform bulk 301 redirects.",
                grade: 4.6,
                comment: "184",
                btn: "Try Free for 7 days",
                img: "/seoant/brokenlinks.png",
                url: "https://apps.shopify.com/broken-link-manager?utm_source=seoant&utm_medium=byseoantpage&utm_campaign=position1",
                isFree: false,
            },
            {
                id: 2,
                title: "SEOAnt ‑ Sticky Add To Cart",
                desc: "Add sticky cart and quick buy icon to get more sales",
                grade: 4.9,
                comment: "411",
                btn: "Try Free for 7 days",
                img: "/seoant/stickycart.png",
                url: "https://apps.shopify.com/sticky-cart-and-sticky-add-to-cart-button?utm_source=seoant&utm_medium=byseoantpage&utm_campaign=position2",
                isFree: false,
            },
            {
                id: 3,
                title: "SEOAnt ‑ Trust Badges & Icon",
                desc: "Boost conversions with diverse trust and shipping badges",
                grade: 4.9,
                comment: "1759",
                btn: "Free to try",
                img: "/seoant/trsutme.png",
                url: "https://apps.shopify.com/trust-badge-by-giraffly?utm_source=seoant&utm_medium=byseoantpage&utm_campaign=position3",
                isFree: true,
            },
            {
                id: 4,
                title: "SEOAnt ‑ Page Speed Optimizer",
                desc: "Enhance your store with Pagespeed",
                grade: 4.8,
                comment: "163",
                btn: "Free to try",
                img: "/seoant/pagespeed.png",
                url: "https://apps.shopify.com/page-speed-boost?utm_source=seoant&utm_medium=byseoantpage&utm_campaign=position4",
                isFree: true,
            }
        ]
    }

    UNSAFE_componentWillMount() {
        const locals = this.props.location;
        let _query = locals.query;
        if (_query && _query !== 'overcharge') {
            this.setState({
                selected: _query.tabkey === 4 ? "Integration" : "Account",
                // setTabKey: _query.tabkey,
            }, () => {
                // if (_query.tabkey === 4) {
                //     this.setScrollCss(1);
                // }
            })
        }

        // 判断是否组合套餐支付跳转
        const paramsSearch = new URLSearchParams(locals.search);
        if (paramsSearch?.get('action') === 'channelwill' || Number(paramsSearch?.get('tabKey')) === 4) {
            this.setState({
                selected: "Integration",
                // setTabKey: 4,
            }, () => {
                this.setScrollCss(1);
            })
        }

        // 固定 选择语言tab
        if (window.fixedLanguage) {
            this.setState({
                selected: "General"
            })
        }
    }

    componentDidMount() {
        let _page = store.getState().page;
        this.setAccountData(_page.pageInit?.settingAcount);
        this.getNotifications();
        this.setDomain();
        store.subscribe(() => {
            this.setDomain();
            // this.getPricingPlan();
        })

        let overchargeTip = true;
        try {
            overchargeTip = !Boolean(sessionStorage.getItem("overcharge_setting"));
        } catch (e) { }
        this.setState({
            isShowOverchargeTip: overchargeTip,
        })
    }

    // 设置域名 || 是否中台用户
    setDomain = () => {
        let _store = store.getState().public;
        let switchData = _store.publicInit.head_data?.switch_data;
        let currentTime = (new Date().getTime()) / 1000;
        this.setState({
            domain: _store.domain,
            isComboUser: Boolean(_store.publicInit.head_data?.is_combo_plan),
            isShowCwAdverSetting: !Boolean(switchData?.cwAdverSettingState),
            isOneTrial: _store.publicInit.meal_data.trial_ends_on > currentTime
        })
    }

    // 价格版本信息
    // getPricingPlan = () => {
    //     let _page = store.getState().page.pageInit;
    //     let _t = _page.pricingPlan;
    //     if(_t.ack === 1) {
    //         let ppid = _t.data.ppid;
    //         this.setState({
    //             c_pricing: ppid === 1 ? 0 : ppid === 2 ? 29.9 : ppid === 4 ? 59.9 : ppid === 8 ? 287.9 : ppid === 9 ? 575.9 : ppid === 10 ? 399 : 0,
    //             ppid,
    //         })
    //     }
    // }

    // 获取周期上线记录
    getUsageRecordList = async () => {
        const res = await reqGetUsageRecordList();
        if (res.ack === 1) {
            // let { exceedUse, exceedAll, points_paid_all, points_paid_use } = this.state;
            // 格式化日期 图片
            let imageList = res.data.filter(i => i.type === 1);
            imageList.forEach((item) => {
                // if (index === 0) {
                //     item['states'] = `${item.img_quota - (exceedAll - exceedUse)}/${item.img_quota}`;
                // } else {
                //     item['states'] = <Badge>{t("Expired")}</Badge>;
                // }
                item['date'] = this.formatDate(item.created_at);
                item['Product'] = `${t("Image")} ${t("Add-on")} : ${item.img_quota}`;
                item['gift'] = 0;
            })
            // Ai
            let aiList = res.data.filter(i => i.type === 2);
            aiList.forEach((item) => {
                // if (index === 0) {
                //     item['states'] = `${item.img_quota - (points_paid_all - points_paid_use)}/${item.img_quota}`;
                // } else {
                //     item['states'] = <Badge>{t("Expired")}</Badge>;
                // }
                item['date'] = this.formatDate(item.created_at);
                item['Product'] = `${t("AI credits")} ${t("Add-on")} : ${item.img_quota}`;
                item['gift'] = item.quota_gift;
            })
            this.setState({
                addoneList: res.data,
                addLoading: false,
            })
        }
    }

    formatDate = (time) => {
        let times = `${new Date(Number(time) * 1000)}`.split(' ');
        return `${times[1]} ${times[2]},${times[3]}`;
    }

    // Account数据
    setAccountData = async (cache = null) => {
        let res = cache || await reqGetAccount();
        this.props.getPageDataRedux(res);
        if ((res && !(res.msg)) || (res.msg && res.msg.indexOf("Expired token") === -1)) {
            const mealData = res.meal_data; // 额度
            let reset_quota = formatTimestamp(res.reset_quota * 1000);
            // 计算各进度条数值
            const _m = mealData;
            let imagesPro = Number(100 * (_m.images_use / _m.images_all));
            let product_pro = Number(100 * (_m.product_use / _m.product_all));
            let points_gift_pro = Number(100 * (_m.points_gift_use / _m.points_gift_all));
            let points_paid_pro = Number(100 * (_m.points_paid_use / _m.points_paid_all));
            let ppid = res.shop.pricing_plan_id;
            this.setState({
                imagesAll: Number(mealData.images_all),
                imagesUse: Number(mealData.images_use),
                points_gift_all: Number(mealData.points_gift_all),
                points_gift_use: Number(mealData.points_gift_use),
                points_paid_all: Number(mealData.points_paid_all),
                points_paid_use: Number(mealData.points_paid_use),
                product_use: Number(mealData.product_use),
                product_all: Number(mealData.product_all),
                exceedUse: Number(mealData.img_usage_use),
                exceedAll: Number(mealData.img_usage_all),
                ap_login_url: res.aps.ap_login_url,
                short_url: res.aps.short_url,
                level: res.shop.level,
                Language: res.shop.language,
                reset_quota: reset_quota,
                loadingPage: false,
                overState: res.is_over_quota, // 是否开启自动增量
                loadingSwitchOver: false,
                is_capped: res.is_capped,
                isRemoveState: Boolean(res?.remove_count),
                removeLoading: false,
                iscacheLoading: cache || false,

                selectCap: Number(res.capped_amount || 100),
                originCap: Number(res.capped_amount || 100),
                selectUSD: `${res.capped_amount || 100} USD`,
                isLimitMax: res.is_excess_limit,

                imagesPro: Number(imagesPro > 100 ? 100 : imagesPro).toFixed(2),          // 进度条
                product_pro: Number(product_pro > 100 ? 100 : product_pro).toFixed(2),
                points_gift_pro: Number(points_gift_pro > 100 ? 100 : points_gift_pro).toFixed(2),
                points_paid_pro: Number(points_paid_pro > 100 ? 100 : points_paid_pro).toFixed(2),

                isApplicable: Number(res.capped_amount) > 0 && res.is_capped,
                overchargeUse: Number(res.balance_used).toFixed(0),
                overchargeAll: Number(res.capped_amount).toFixed(0),
                c_pricing: ppid === 1 ? 0 : ppid === 2 ? 29.9 : ppid === 4 ? 59.9 : ppid === 8 ? 287.9 : ppid === 9 ? 575.9 : ppid === 10 ? 399 : 0,
                ppid,
                uid: res.shop.id,
            }, () => {
                if (cache) {
                    this.setAccountData();
                }
                this.getUsageRecordList();

                const locals = this.props.location;

                // 如果是开超额，定位到开关
                const objs = document.getElementById('OverchargeBlock');
                if (locals?.query === 'overcharge' && objs) {
                    window.scrollTo(0, objs.getBoundingClientRect().top, "smooth");
                }

                // 用户 超额黑名单
                if (res.shop.id === 64672 && res.is_over_quota) {
                    this.setState({
                        overState: false,
                    }, () => {
                        this.requestStateSet('is_over_quota', 0)
                    })
                }
            })
        } else {
            this.props.toggleToast(res.msg, true);
        }
    }

    // 获取邮箱等信息
    getNotifications = async () => {
        const res = await reqGetNotification();
        if (Boolean(res.back_link)) {
            this.setState({
                eamilUser: res.back_link.email,
                exchangeChecked: Boolean(res.back_link.switch),
                eamilBro: res.report_404.email,
                broChecked: Boolean(res.report_404.switch),
                frequency: res.report_404.rep_freq,
                NotificationData: res,
            })
        } else {
            this.props.toggleToast('Error', true);
        }
    }

    // 选择
    setSelected = (e) => {
        if (this.state.isShowSaveBar) {
            const isShopify = window.shopify;
            if (isShopify) {
                isShopify.saveBar.leaveConfirmation();
            }
        } else {
            this.setState({
                selected: e[0],
                isShowSaveBar: false,
                saveBtnLoading: false,
            })
        }
    }

    // 跳转价格页
    jumpPricingPage = (type = 'month') => {
        utils.routeJump(this, '/plan', null, type)
    }

    // 选择语言
    changeLanguage = (val) => {
        // 修改缓存
        window.language = val;
        window.fixedLanguage = true;
        store.dispatch(setLangState(false)); // 重置语言状态
        this.setSaveState(0, false, 'disabled');
        this.setSaveState(0, true, 'loading');
        this.props.changeLanguageStatus(val); // 缓存全局状态
        this.setState({
            Language: val,
            loadingSwitch: true,
        }, async () => {
            const params = {
                Language: val,
            };
            const res = await reqUpdateLanguage(params)
            if (res.code === 200) {
                this.updCioLanguage(val);
                this.props.toggleToast(t("Success"), false)
                this.setSaveState(0, true, 'disabled');
                this.setState({
                    loadingSwitch: false,
                })
            } else {
                this.props.toggleToast(res.msg, true)
                this.setState({
                    loadingSwitch: false,
                })
            }
            if (res) {
                this.setSaveState(0, false, 'loading');
            }
        })
    }

    // 设置email
    handleEamilChange = (val, type) => {
        this.setSaveState(1, false, 'disabled');
        let error = type === 'eamilBro' ? 'emailError' : 'backlinkError';
        this.setState({
            [type]: val,
            [error]: '',
        }, () => {
            this.checkChangeState();
        })
    }

    // check状态
    handleCheckChange = (type) => {
        if (type === 'isRemoveState') {
            this.setState({
                isRemoveState: !this.state.isRemoveState,
                removeLoading: true,
            }, () => {
                this.handleRemoveState();
            })
        } else {
            this.setSaveState(1, false, 'disabled');
            this.setState({
                [type]: !this.state[type],
            }, () => {
                this.checkChangeState();
            })
        }
    }

    // 删除开关
    handleRemoveState = async () => {
        let { isRemoveState } = this.state;
        let params = {
            status: Number(isRemoveState),
        }
        const res = await reqSetReCountStatus(params);
        if (res.ack === 1) {
            this.props.toggleToast(res.msg);
            this.setState({
                removeLoading: false,
            })
        } else {
            this.props.toggleToast(t("Try again later"), true);
            this.setState({
                removeLoading: false,
                isRemoveState: !isRemoveState
            })
        }
    }

    // 选择下拉
    selectReportItem = (e) => {
        this.setSaveState(1, false, 'disabled');
        this.setState({
            frequency: Number(e),
        }, () => {
            this.checkChangeState();
        })
    }

    // 判断是否修改
    checkChangeState = () => {
        let { NotificationData, frequency, eamilBro, eamilUser, broChecked, exchangeChecked } = this.state;
        let _t = NotificationData;
        if (frequency === _t.report_404.rep_freq && eamilBro === _t.report_404.email && eamilUser === _t.back_link.email && Boolean(broChecked) === Boolean(_t.report_404.switch) && Boolean(exchangeChecked) === Boolean(_t.back_link.switch)) {
            this.setState({
                isShowSaveBar: false,
            })
        } else {
            this.setState({
                isShowSaveBar: true,
            })
        }
    }

    // 保存状态
    setSaveState = (index, state, type) => {
        let saveState = {};
        if (type === 'disabled') {
            saveState = cloneDeep(this.state.saveDisabled);
        } else {
            saveState = cloneDeep(this.state.saveLoading);
        }

        saveState[index] = state;
        this.setState(
            type === 'disabled' ? {
                saveDisabled: saveState
            } : {
                saveLoading: saveState
            })
    }

    // 打开facebook
    openAppAction = () => {
        let iWidth = 650;
        let iHeight = 700;
        let iTop = (window.screen.availHeight - 30 - iHeight) / 2;
        let iLeft = (window.screen.availWidth - 10 - iWidth) / 2;
        let targetUrl = `https://facebook.com/sharer/sharer.php?u=${this.state.short_url}`;
        window.open(targetUrl, 'about:blank', 'height=' + iHeight + ',,innerHeight=' + iHeight + ',width=' + iWidth + ',innerWidth=' + iWidth + ',top=' + iTop + ',left=' + iLeft + ',status=no,toolbar=no,menubar=no,location=no,resizable=no,scrollbars=0,titlebar=no');
    }

    // 打开复制链接
    openLinkAffiliate = (url) => {
        this.props.toggleToast(t("Copy successfully!"), false);
        utils.CopyText(url);
        setTimeout(() => {
            window.open(url)
        }, 500)
    }

    //点击联系客服
    handleContactService = () => {
        try {
            showNewMessage()
        } catch (e) {
            this.props.toggleToast(t("Try again later"), true);
        }
    }

    // 增量状态修改
    changeOverState = (e) => {
        this.setState({
            loadingSwitchOver: true,
            overState: Boolean(e)
        }, () => {
            this.requestStateSet('is_over_quota', Number(e)).then(res => {
                if (res) {
                    this.setState({
                        loadingSwitchOver: false,
                    })
                }

                if (res.ack !== 1) {
                    this.setState({
                        overState: !Boolean(e)
                    })
                } else {
                    this.setState({
                        selectCap: this.state.originCap,
                        isShowSaveBar: false,
                    })
                    this.setSaveState(1, false, 'loading');
                }
            })
        })
    }

    // 选择cap
    handleSelectCap = (e) => {
        this.setState({
            selectCap: Number(e)
        })
    }

    // 保存cap
    changeCapValue = () => {
        this.setSaveState(1, true, 'loading');
        this.setState({
            capLoading: true
        }, async () => {
            let { selectCap, originCap } = this.state;
            if (selectCap === originCap) {
                this.setState({
                    capLoading: false,
                    capState: false,
                })
                this.props.toggleToast(t("Success"));
            } else {
                let params = {
                    amount: selectCap
                }
                const res = await reqUpdExcessLimit(params);
                if (res.ack === 1) {
                    // this.props.toggleToast(res.msg);
                    this.setState({
                        selectUSD: `${selectCap} USD`,
                        originCap: selectCap,
                        capLoading: false,
                        isShowSaveBar: false,
                    }, () => {
                        setTimeout(() => {
                            window.open(res.data.confirmationUrl)
                        }, 500)
                    })
                } else {
                    this.setState({
                        capLoading: false,
                        isShowCapTip: res.msg,
                        overchargeError: res.msg,
                    })
                }
                if (res) {
                    this.setSaveState(1, false, 'loading');
                }
            }
        })
    }

    // 关闭cap弹窗
    closeCapModal = () => {
        this.setState({
            capState: false,
            selectCap: 100,
            isShowCapTip: false,
        })
    }

    // tab切换
    handleTabsSel = (e) => {
        this.setState({
            setTabKey: e
        }, () => {
            // this.setScrollCss(e === 4 ? 1 : 0);
        })
    }

    // 操作滚动条
    setScrollCss = (isSet = 0) => {
        if (isSet) {
            // 动态插入 CSS 来隐藏滚动条
            const style = document.createElement('style');
            style.innerHTML = `
                .isSetScrollHidden{}
                ::-webkit-scrollbar {
                    width: 0;
                    height: 0;
                }
            `;
            document.head.appendChild(style);
            this.props.setScrollHidden(true);
        } else {
            // 动态删除之前插入的样式，恢复滚动条
            if (this.props.public.isHiddenScroll) {
                const styleTags = document.head.getElementsByTagName('style');
                for (let i = 0; i < styleTags.length; i++) {
                    if (styleTags[i].innerHTML.includes('.isSetScrollHidden{}')) {
                        document.head.removeChild(styleTags[i]);
                    }
                }
                this.props.setScrollHidden(false);
            }
        }
    }

    // 关掉cw广告
    closeSettingCwAdver = () => {
        this.setState({
            isShowCwAdverSetting: false,
        }, () => {
            this.requestStateSet('cwAdverSettingState', 1, true);
        })
    }

    // 输入超额
    handleOverchargeChange = (e) => {
        let { originCap } = this.state;
        this.setState({
            selectCap: e,
            overchargeError: "",
            isShowSaveBar: e > originCap
        })
    }
    onSpinnerOvercharge = (e, i) => {
        let { selectCap, originCap } = this.state;
        let _n = Number(selectCap);
        let newCap = _n < Number(e) ? _n + 100 : (_n < 100 ? _n - 1 : _n - 100);
        if (newCap >= 0) {
            this.setState({
                selectCap: newCap,
                overchargeError: "",
                isShowSaveBar: newCap > originCap
            })
        }
    }

    // 失焦 超额
    onOverchargeSet = (_state) => {
        let { selectCap, originCap } = this.state;
        if (!_state) {
            this.setState({
                selectCap: originCap,
                overchargeError: "",
                isShowSaveBar: false,
            })
        } else {
            if (selectCap < originCap) {
                this.setState({
                    overchargeError: t("Please enter an amount above ${{v1}} USD", originCap)
                })
            } else {
                this.setState({
                    overchargeError: "",
                }, () => {
                    this.changeCapValue();
                })
            }
        }
    }

    // 关闭提示
    closeOverchargeTip = () => {
        this.setState({
            isShowOverchargeTip: false,
        }, () => {
            try {
                sessionStorage.setItem("overcharge_setting", "close");
            } catch (e) { }
        })
    }

    // 判断是否修改
    setShowSaveBarState = (state, action) => {
        this.$SiteVerify = action;
        this.setState({
            isShowSaveBar: state
        })
    }

    // 保存Notifications
    saveNotifications = () => {
        let { eamilUser, eamilBro, broChecked, exchangeChecked, frequency, NotificationData } = this.state;
        let reg = /^([a-zA-Z0-9._-])+@([a-zA-Z0-9_-])+(.[a-zA-Z0-9_-])+/;
        if (Boolean(broChecked) && eamilBro === '') {
            this.setState({
                emailError: "The email account cannot be empty"
            })
        } else if (Boolean(broChecked) && !reg.test(eamilBro)) {
            this.setState({
                emailError: "Please fill in the correct email address"
            })
        } else if (Boolean(exchangeChecked) && eamilUser === '') {
            this.setState({
                backlinkError: "The email account cannot be empty"
            })
        } else if (Boolean(exchangeChecked) && !reg.test(eamilUser)) {
            this.setState({
                backlinkError: "Please fill in the correct email address"
            })
        } else {
            this.setSaveState(1, true, 'loading');
            this.setState({}, async () => {
                let params = {
                    report_404: JSON.stringify({
                        email: eamilBro,
                        switch: Number(broChecked),
                        rep_freq: Number(frequency),
                    }),
                    back_link: JSON.stringify({
                        email: eamilUser,
                        switch: Number(exchangeChecked),
                    }),
                }
                // 未更新的数据删除不传
                let editObj = ['report_404', 'back_link'];
                if (Object.keys(NotificationData['report_404']).filter(i => JSON.parse(params['report_404'])[i] === NotificationData['report_404'][i]).length === 3) {
                    editObj.splice(editObj.indexOf('report_404'), 1);
                    delete params['report_404'];
                }
                if (Object.keys(NotificationData['back_link']).filter(i => JSON.parse(params['back_link'])[i] === NotificationData['back_link'][i]).length === 2) {
                    editObj.splice(editObj.indexOf('back_link'), 1);
                    delete params['back_link'];
                }
                const res = await reqSetNotification(params);
                if (res.ack === 1) {
                    this.props.toggleToast(res.msg, false)
                    this.setSaveState(1, true, 'disabled');
                    let notificationData = cloneDeep(NotificationData);
                    if (editObj.includes('report_404')) {
                        notificationData['report_404'] = JSON.parse(params['report_404']);
                    }
                    if (editObj.includes('back_link')) {
                        notificationData['back_link'] = JSON.parse(params['back_link']);
                    }
                    this.setState({
                        NotificationData: notificationData,
                        isShowSaveBar: false,
                        emailError: "",
                        backlinkError: "",
                    })
                } else {
                    if (res.msg === "Please enable the external link exchange function first!") {
                        this.setState({
                            NotOpenBacklink: true,
                        })
                    } else {
                        this.props.toggleToast(res.msg, true)
                    }
                }
                if (res) {
                    this.setSaveState(1, false, 'loading');
                }
            })
        }
    }
    // 舍弃Notifications
    discardNotifications = () => {
        let { NotificationData } = this.state;
        let _t = NotificationData;
        this.setState({
            eamilBro: _t.report_404.email,
            exchangeChecked: Boolean(_t.report_404.switch),
            frequency: _t.report_404.rep_freq,
            broChecked: Boolean(_t.back_link.switch),
            eamilUser: _t.back_link.email,
            isShowSaveBar: false,
        })
    }

    // 保存Site Verifications
    saveSiteVerifications = () => {
        this.setSaveState(1, true, 'loading');
        this.$SiteVerify.onChangeVerifyData();
    }
    // 舍弃Site Verifications
    discardSiteVerifications = () => {
        this.setState({
            isShowSaveBar: false,
        }, () => {
            if (this.$SiteVerify) {
                this.$SiteVerify.discardVerifyData();
            }
        })
    }

    // 保存数据
    saveDataInfo = () => {
        let { selected } = this.state;
        switch (selected) {
            case "Account":
                this.onOverchargeSet(true);
                break;
            case "Notifications":
                this.saveNotifications();
                break;
            case "SiteVerifications":
                this.saveSiteVerifications();
                break;
            default:
                break;
        }
    }

    // 舍弃
    handleDiscardAction = () => {
        let { selected } = this.state;
        // 根据tab修改
        switch (selected) {
            case "Account":
                this.onOverchargeSet(false);
                break;
            case "Notifications":
                this.discardNotifications();
                break;
            case "SiteVerifications":
                this.discardSiteVerifications();
                break;
            default:
                break;
        }
    }

    // 切换
    handleInterTabChange = (e) => {
        this.setState({
            interSelect: e
        })
    }

    // 发送请求
    requestStateSet = async (type, state, isSwitch = false) => {
        const params = {
            name: `${type}`,
            st: Number(state),
            exp: 0,
            type: `param`
        }
        const res = await reqSaveSwitchState(params);
        if (res.ack === 1) {
            if (!isSwitch) {
                this.props.toggleToast('Succeed', false);
            } else {
                let data = cloneDeep(this.props.public.publicInit.head_data?.switch_data)
                if (typeof data === 'boolean') {
                    data = [];
                }
                data[`${type}`] = { "at": Math.floor(new Date().getTime() / 1000), "st": 1, "exp": 0 };
                this.props.setSwitchData(data);
            }
        } else {
            this.props.toggleToast(t("Try again later"), true);
        }

        return res;
    }

    // 更新cio语言
    updCioLanguage = (e) => {
        try {
            const CompLang = {
                "cs": "cs",
                "da": "da",
                "ge": "de",
                "en": "en",
                "sp": "es",
                "fr": "fr",
                "it": "it",
                "in": "in",
                "dut": "nl",
                "nb": "nb",
                "pl": "pl",
                "pt_BR": "pt-BR",
                "pt": "pt-PT",
                "fi": "fi",
                "sv": "sv",
                "tr": "tr",
                "th": "th",
                "ja": "ja",
                "zh": "zh-CN",
                "zh_hant": "zh-TW",
                "ko": "ko",
            }
            if (window.shopify && window.cio?.initialized) {
                window.cio?.changeLanguage(CompLang[e] || 'en');
            }
        } catch { }
    }

    componentWillUnmount = () => {
        window.fixedLanguage = false;
    }

    render() {
        const {
            loadingPage,
            selected,
            // ImageFreeQuota,
            imagesAll,
            imagesUse,
            points_gift_all,
            points_gift_use,
            points_paid_all,
            points_paid_use,
            product_use,
            product_all,
            level,
            ap_login_url,
            short_url,
            Language,
            saveLoading,
            // saveDisabled,
            eamilUser,
            eamilBro,
            broChecked,
            exchangeChecked,
            frequency,
            loadingSwitch,
            reset_quota,
            emailError,
            backlinkError,
            NotOpenBacklink,
            // exceedUse,
            // exceedAll,
            addoneList,
            addLoading,
            overState,
            loadingSwitchOver,
            is_capped,
            isRemoveState,
            removeLoading,
            // selectUSD,
            // capState,
            selectCap,
            originCap,
            capLoading,
            // isShowCapTip,
            isLimitMax,
            iscacheLoading,
            domain,
            setTabKey,
            isComboUser,
            isShowCwAdverSetting,
            // imagesPro,
            // product_pro,
            // points_gift_pro,
            // points_paid_pro,
            overchargeError,
            isOneTrial,
            isShowOverchargeTip,
            isShowSaveBar,
            // saveBtnLoading,
            isApplicable,
            overchargeUse,
            overchargeAll,
            ppid,
            c_pricing,
            uid,
            interSelect,
            AppList,

        } = this.state;

        const _info = this.props.public.Language; // 缓存语言

        // 判断是否shopify内嵌模式
        const shopifyMode = store.getState().public.isShowTopMenu || 1;

        // 星星
        const starArr = <div className='five_star'>
            {
                [1, 2, 3, 4, 5].map(item => {
                    return <svg key={item} width="16" height="15" viewBox="0 0 16 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M8 0L10.8214 4.11672L15.6085 5.52786L12.5651 9.48328L12.7023 14.4721L8 12.8L3.29772 14.4721L3.43493 9.48328L0.391548 5.52786L5.17863 4.11672L8 0Z" fill="#FFAC3D" />
                    </svg>
                })
            }
        </div>

        // SEOAnt列表
        const SEOAntBlock = <div className="By_SEOAnt">
            <BlockStack gap={400}>
                {
                    AppList.map(item => {
                        return <Card padding={0} key={item.id}>
                            <div className="seoant_item">
                                <div className="seoant_img"><img src={item.img} alt="" /></div>
                                <div className="seoant_info">
                                    <Text variant="headingMd" as="h2">{item.title}</Text>
                                    <Text variant="bodyMd" as="p">
                                        {`${item.grade} (${item.comment})`}
                                        {
                                            item.isFree && <span> * <span style={{ color: "#7126EF" }}>Free</span></span>
                                        }
                                    </Text>
                                    {starArr}
                                    <Text variant="bodyMd" as="p">{item.desc}</Text>
                                    <div><Button variant="primary" onClick={() => {
                                        window.open(item.url)
                                    }}>{item.btn}</Button></div>
                                </div>
                            </div>
                        </Card>
                    })
                }
            </BlockStack>
        </div>

        //图片额度进度条
        // let ImageProgressBarClassName = "";
        //进度条的颜色
        // let OnPageProgressBarClassName = "";
        // let planTitle = "";
        // let ImageComboByCardContent = "";
        // let OnPageComboByCardContent = "";
        // let OnpageCreditsContent = "";

        // if (level === 3) {
        //     planTitle = <span>{t("Premium Plan")}</span>
        //     ImageComboByCardContent = <div className="Polaris-ProgressBar__Content">
        //         <label style={{ fontSize: "13px" }}>{t("Image Quota")} : {imagesUse} / {imagesAll}</label>
        //         <div className={`${(!Boolean(imagesAll) || Number(imagesUse / imagesAll) >= 0.8) ? 'ProgressBarRed' : 'ProgressBarGreen'}`} title={imagesPro + "%"}>
        //             <ProgressBar animated={false} progress={imagesPro} size="small" />
        //         </div>
        //     </div>

        //     OnPageComboByCardContent = <label style={{ fontSize: "13px" }}>{t("On-page SEO Scan Quota")} : {product_use} / {t("unlimited")}</label>
        // } else if (level === 2) {
        //     planTitle = <span>{t("Pro Plan")}</span>

        //     ImageComboByCardContent = <div className="Polaris-ProgressBar__Content">
        //         <label style={{ fontSize: "13px" }}>{t("Image Quota")} : {imagesUse} / {imagesAll}</label>
        //         <div className={`${(!Boolean(imagesAll) || Number(imagesUse / imagesAll) >= 0.8) ? 'ProgressBarRed' : 'ProgressBarGreen'}`} title={imagesPro + "%"}>
        //             <ProgressBar animated={false} progress={imagesPro} size="small" />
        //         </div>
        //     </div>

        //     OnPageComboByCardContent = <div className="Polaris-ProgressBar__Content">
        //         <label style={{ fontSize: "13px" }}>{t("On-page SEO Scan Quota")} : {product_use} / {product_all}</label>
        //         <div className={`${(!Boolean(product_all) || Number(product_use / product_all) >= 0.8) ? 'ProgressBarRed' : 'ProgressBarGreen'}`} title={product_pro + "%"}>
        //             <ProgressBar animated={false} progress={product_pro} size="small" />
        //         </div>
        //     </div>

        // } else if (level === 1) {
        //     planTitle = <span>{t("Free Plan")}</span>
        //     if (Boolean(imagesAll) && Number(imagesUse / imagesAll) >= 0.8) {
        //         ImageProgressBarClassName = "ProgressBarRed"
        //     } else {
        //         ImageProgressBarClassName = "ProgressBarGreen"
        //     }

        //     if (Boolean(product_all) && Number(product_use / product_all) >= 0.8) {
        //         OnPageProgressBarClassName = "ProgressBarRed"
        //     } else {
        //         OnPageProgressBarClassName = "ProgressBarGreen"
        //     }

        //     ImageComboByCardContent = <div className="Polaris-ProgressBar__Content">
        //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItem: 'center' }}>
        //             <label style={{ fontSize: "13px" }}>{t("Image Quota")} : {imagesUse} / {imagesAll}</label>
        //         </div>
        //         <div className={ImageProgressBarClassName} style={{ position: 'relative' }}>
        //             {(imagesAll >= ImageFreeQuota || imagesUse >= ImageFreeQuota) ?
        //                 null : <div style={{ padding: '0.4rem', width: '100%', position: 'absolute', top: '0', left: '0.1rem', borderRadius: '1rem' }}></div>
        //             }
        //             <div style={{ position: 'relative', zIndex: '1' }} title={imagesPro + "%"}>
        //                 <ProgressBar animated={false} progress={imagesPro} size="small" />
        //             </div>
        //         </div>
        //     </div>

        //     OnPageComboByCardContent = <div className="Polaris-ProgressBar__Content">
        //         <div style={{ display: 'flex', justifyContent: 'space-between', alignItem: 'center' }}>
        //             <label style={{ fontSize: "13px" }}>{t("On-page SEO Scan Quota")} : {product_use} / {product_all}</label>
        //         </div>
        //         <div className={OnPageProgressBarClassName} style={{ position: 'relative' }}>
        //             {(product_all >= this.state.OnPagefreeQuota || product_use >= this.state.OnPagefreeQuota) ?
        //                 null : <div style={{ padding: '0.4rem', width: '100%', position: 'absolute', top: '0', left: '0.1rem', borderRadius: '1rem' }}></div>
        //             }
        //             <div style={{ position: 'relative', zIndex: '1' }} title={product_pro + "%"}>
        //                 <ProgressBar animated={false} progress={product_pro} size="small" />
        //             </div>
        //         </div>
        //     </div>
        // }

        // OnpageCreditsContent = <div className="Polaris-ProgressBar__Content">
        //     {
        //         points_paid_all !== 0 ? <>
        //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItem: 'center' }}>
        //                 <label style={{ fontSize: "13px" }}>{t("AI credits")}</label>
        //             </div>
        //             <div className='AI-Writer-View'>
        //                 <div className={`${points_gift_pro > 80 ? 'ProgressBarRed' : 'ProgressBarGreen'} plan`} style={{ position: 'relative' }}>
        //                     <div style={{ position: 'relative', zIndex: '1' }} title={points_gift_pro + "%"}>
        //                         <p style={{ fontSize: '0.7rem', whiteSpace: 'pre' }}>{t("Used/Plan's AI Credits")}:&nbsp;&nbsp;{`${points_gift_use}/${points_gift_all}`}</p>
        //                         {points_gift_all > 0 ?
        //                             <ProgressBar animated={false} progress={points_gift_pro} size="small" /> : <ProgressBar animated={false} progress={0} size="small" />}
        //                     </div>
        //                 </div>
        //                 {(points_paid_use === 0 && points_paid_all === 0) ? null : <div className={`${points_paid_pro > 80 ? 'ProgressBarRed' : 'ProgressBarGreen'} Purchase`} style={{ position: 'relative' }}>
        //                     <div style={{ position: 'relative', zIndex: '1' }} title={points_paid_pro + "%"}>
        //                         <p style={{ fontSize: '0.7rem', whiteSpace: 'pre' }}>{t("Used/Purchase AI Credits")}:&nbsp;&nbsp;{`${points_paid_use}/${points_paid_all}`}</p>
        //                         {points_paid_all > 0 ?
        //                             <ProgressBar animated={false} progress={points_paid_pro} size="small" /> : <ProgressBar animated={false} progress={0} size="small" />}
        //                     </div>
        //                 </div>}
        //             </div>
        //         </> : <>
        //             <div style={{ display: 'flex', justifyContent: 'space-between', alignItem: 'center' }}>
        //                 <label style={{ fontSize: "13px" }}>{t("AI credits")}&nbsp;:&nbsp;{`${points_gift_use} / ${points_gift_all}`}</label>
        //             </div>
        //             <div className='AI-Writer-View'>
        //                 <div className={`${points_gift_pro > 80 ? 'ProgressBarRed' : 'ProgressBarGreen'} plan`} style={{ position: 'relative' }}>
        //                     <div style={{ position: 'relative', zIndex: '1' }} title={points_gift_pro + "%"}>
        //                         {points_gift_all > 0 ?
        //                             <ProgressBar animated={false} progress={points_gift_pro} size="small" /> : <ProgressBar animated={false} progress={0} size="small" />}
        //                     </div>
        //                 </div>
        //             </div>
        //         </>
        //     }
        // </div>

        // 超额额度上限
        const OverChargeAllLimit = (level !== 1 && is_capped && overState && !isComboUser) && <div>
            <div className='Image_Optimize_Limit'>
                <label>{t("Current spending limit")}:</label>
                <div className='overcharg_setting'>
                    <TextField
                        type="number"
                        value={selectCap}
                        onChange={this.handleOverchargeChange}
                        onSpinnerChange={this.onSpinnerOvercharge}
                        prefix="$"
                        suffix="USD"
                        autoComplete="off"
                    // error={overchargeError}
                    />
                </div>
                {/* <div className='flex_layout' style={{ display: selectCap > originCap ? "flex" : "none" }}>
                    <Button size='micro' disabled={capLoading} onClick={() => this.onOverchargeSet(false)}>{t("Cancel")}</Button>
                    <Button size='micro' loading={capLoading} variant='primary' onClick={() => this.onOverchargeSet(true)}>{t("Save")}</Button>
                </div> */}
                {/* <p onClick={() => {
                    this.setState({ capState: true })
                }}>
                    <span>{selectUSD}</span>
                    <Icon source={ChevronDownMinor} />
                </p> */}
            </div>
            {
                Boolean(overchargeError) || (selectCap < originCap) ? <p className='image_quota_limit'>
                    <span><Icon source={CircleAlertMajor} /></span>
                    <span>{t("Please enter an amount above ${{v1}} USD", originCap)}</span>
                </p> : (isLimitMax && <p className='image_quota_limit'>
                    <span><Icon source={CircleAlertMajor} /></span>
                    <span>{t("The App spending limit has been reached, no further charges can be made.")}</span>
                </p>)
            }
        </div>
        // 确认弹窗
        // const overchargeConfirmModal = <Modal
        //     open={}
        // >

        // </Modal>

        // const capModal = <Modal
        //     open={capState}
        //     title={t("Select monthly cap")}
        //     primaryAction={{
        //         content: t("Save"),
        //         onAction: this.changeCapValue,
        //         loading: capLoading,
        //     }}
        //     secondaryActions={[
        //         {
        //             content: t("Cancel"),
        //             onAction: this.closeCapModal,
        //             disabled: capLoading,
        //         }
        //     ]}
        //     onClose={this.closeCapModal}
        // >
        //     <div style={{ padding: '1rem' }}>
        //         <BlockStack gap={400}>
        //             {
        //                 isShowCapTip && <Banner
        //                     title={isShowCapTip}
        //                     tone="critical"
        //                     onDismiss={() => {
        //                         this.setState({
        //                             isShowCapTip: ''
        //                         })
        //                     }}
        //                     action={{
        //                         content: t("contact us"),
        //                         onAction: this.handleContactService
        //                     }}
        //                 >
        //                 </Banner>
        //             }
        //             <Select
        //                 label=""
        //                 options={[
        //                     { label: '100 USD', value: 100 },
        //                     { label: '200 USD', value: 200 },
        //                     { label: '300 USD', value: 300 },
        //                     { label: '400 USD', value: 400 },
        //                     { label: '500 USD', value: 500 },
        //                     { label: '1000 USD', value: 1000 },
        //                 ]}
        //                 onChange={this.handleSelectCap}
        //                 value={selectCap}
        //             />
        //         </BlockStack>
        //     </div>
        // </Modal>

        // 超额付费额度
        // let ImageExceedCardContent = exceedAll > 0 && <div className="Polaris-ProgressBar__Content">
        //     <label style={{ fontSize: "13px" }}>{t("Image Add-ons")}: {exceedUse} / {exceedAll}</label>
        //     <div className={`${(!Boolean(exceedAll) || Number(exceedUse / exceedAll) <= 0.8) ? 'ProgressBarGreen' : 'ProgressBarRed'}`} title={(100 * (exceedUse / exceedAll)).toFixed(2) + "%"}>
        //         <ProgressBar progress={exceedAll === 0 ? 0 : (100 * (exceedUse / exceedAll).toFixed(2))} size="small" />
        //     </div>
        // </div>

        // 任务奖励
        // const TaskReward = <div className='task_reward'>
        //     <label style={{ fontSize: "13px" }}>{t("Balance")} : {'$99'}</label>
        //     <Button variant='plain'>{t("Get More Offers")}</Button>
        // </div>

        // 左侧选择
        const leftChoice = <div className='left_choice'>
            <Card padding={100}>
                <OptionList
                    title=""
                    onChange={this.setSelected}
                    options={[
                        { value: "Account", label: t("Account") },
                        { value: "General", label: t("General") },
                        { value: "Notifications", label: t("Notifications") },
                        { value: "Integration", label: t("Integration") },
                        { value: "SiteVerifications", label: t("Site Verifications") },
                        // { value: "Solutionexpert", label: t("Solution expert") },
                    ]}
                    selected={selected}
                />
            </Card>
        </div>

        // 右侧内容
        const rightContent = <div className="right_content">
            {
                selected === "Account" ? <BlockStack gap={400}>
                    <Card>
                        <BlockStack gap={400}>
                            <div className='flex_layout' style={{ justifyContent: 'space-between' }}>
                                <div>
                                    <Text variant="headingMd" as="h2">{level === 3 ? t("Premium plan") : level === 2 ? t("Pro plan") : t("Free plan")}</Text>
                                    <div className="price-container">
                                        <Text variant="headingMd" as='p'>${c_pricing}</Text>
                                        <span className="price-unit">USD/{`${[8, 9].includes(ppid) ? t("year") : t("month")}`}</span>
                                    </div>
                                </div>
                                {
                                    [8, 9, 10].includes(ppid) ? null :
                                        <div className="yearly-savings flex_layout" onClick={() => this.jumpPricingPage('year')}>
                                            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <path fillRule="evenodd" clipRule="evenodd" d="M9.52725 1.32704C8.92776 0.0211954 7.07219 0.0211949 6.47271 1.32704C6.10595 2.12592 5.1855 2.50719 4.36127 2.20162C3.014 1.70215 1.70191 3.01424 2.20138 4.36151C2.50695 5.18574 2.12568 6.1062 1.3268 6.47295C0.0209508 7.07244 0.0209511 8.92801 1.3268 9.52749C2.12568 9.89425 2.50695 10.8147 2.20138 11.6389C1.70191 12.9862 3.014 14.2983 4.36127 13.7988C5.1855 13.4933 6.10595 13.8745 6.47271 14.6734C7.07219 15.9792 8.92776 15.9792 9.52725 14.6734C9.894 13.8745 10.8145 13.4933 11.6387 13.7988C12.986 14.2983 14.298 12.9862 13.7986 11.6389C13.493 10.8147 13.8743 9.89425 14.6732 9.52749C15.979 8.92801 15.979 7.07244 14.6732 6.47295C13.8743 6.1062 13.493 5.18574 13.7986 4.36151C14.298 3.01424 12.986 1.70215 11.6387 2.20163C10.8145 2.50719 9.894 2.12592 9.52725 1.32704ZM6.99998 6.25022C6.99998 6.80251 6.55226 7.25022 5.99998 7.25022C5.44769 7.25022 4.99998 6.80251 4.99998 6.25022C4.99998 5.69794 5.44769 5.25022 5.99998 5.25022C6.55226 5.25022 6.99998 5.69794 6.99998 6.25022ZM10.5303 6.78055L6.53031 10.7806C6.23741 11.0734 5.76254 11.0734 5.46965 10.7806C5.17675 10.4877 5.17675 10.0128 5.46965 9.71989L9.46965 5.71989C9.76254 5.427 10.2374 5.427 10.5303 5.71989C10.8232 6.01278 10.8232 6.48766 10.5303 6.78055ZM11 10.2502C11 10.8025 10.5523 11.2502 9.99998 11.2502C9.44769 11.2502 8.99998 10.8025 8.99998 10.2502C8.99998 9.69794 9.44769 9.25022 9.99998 9.25022C10.5523 9.25022 11 9.69794 11 10.2502Z" fill="#005BD3" />
                                            </svg>
                                            <span>{t("Pay yearly and save ${{v1}}/year", ([1, 4].includes(ppid) ? 144 : [2].includes(ppid) ? 72 : 0))}</span>
                                        </div>
                                }
                            </div>
                            <div>
                                {/* Usage Statistics */}
                                <div className="quota-container">
                                    <div className="quota-header">
                                        <span>{t("Image Quota")}</span>
                                        <div className='quota-dash'></div>
                                        <span className='quota-value'>{imagesUse}/{imagesAll}</span>
                                    </div>
                                </div>
                                <div className="quota-container">
                                    <div className="quota-header">
                                        <span>{t("Used/Plan's AI Credits")}</span>
                                        <div className='quota-dash'></div>
                                        <span className='quota-value'>{points_gift_use}/{points_gift_all}</span>
                                    </div>
                                </div>
                                <div className="quota-container" style={{ display: points_paid_all === 0 ? "none" : "" }}>
                                    <div className="quota-header">
                                        <span>{t("Used/Purchase AI Credits")}</span>
                                        <div className='quota-dash'></div>
                                        <span className='quota-value'>{points_paid_use}/{points_paid_all}</span>
                                    </div>
                                </div>
                                <div className="quota-container">
                                    <div className="quota-header">
                                        <span>{t("On-page SEO Scan Quota")}</span>
                                        <div className='quota-dash'></div>
                                        <span className='quota-value'>{product_use}/{`${level === 3 ? t("unlimited") : product_all}`}</span>
                                    </div>
                                </div>
                                <div className="info-row">
                                    <span><span className="spending-limit" onClick={() => {
                                        window.open("https://help.shopify.com/en/manual/your-account/manage-billing/your-invoice/apps#app-usage-charges")
                                    }}>{t("Spending limit")}</span>&nbsp;{t("for usage charges")}</span>
                                    <div className='quota-dash'></div>
                                    {
                                        isApplicable ? <span className='quota-value'>${overchargeUse}/${overchargeAll}</span> : <span className='quota-value'>{t("Not applicable")}</span>
                                    }

                                </div>
                                {
                                    level > 1 && <div className="info-row">
                                        <span>{t("Next quota reset date")}</span>
                                        <div className='quota-dash'></div>
                                        <span className='quota-value'>{reset_quota}</span>
                                    </div>
                                }
                            </div>
                            <div className='set_select_plan'>
                                <div>
                                    <BlockStack gap={200}>
                                        <div className='flex_layout_betw'>
                                            <Text variant="headingMd" as="h2">{t("Premium Plan features")}</Text>
                                            {
                                                level === 3 && <Button variant='plain' onClick={() => this.jumpPricingPage('month')}>{t("View more")}</Button>
                                            }
                                        </div>
                                        <div className="feature-item">
                                            <div className="checkmark">
                                                <Icon source={CheckOutIcon} tone="base" />
                                            </div>
                                            <span>{t("Rocket site Speed up")} ⚡⚡</span>
                                        </div>
                                        <div className="feature-item">
                                            <div className="checkmark">
                                                <Icon source={CheckOutIcon} tone="base" />
                                            </div>
                                            <span>{t("Monitor your website's keywords")}</span>
                                        </div>
                                        <div className="feature-item">
                                            <div className="checkmark">
                                                <Icon source={CheckOutIcon} tone="base" />
                                            </div>
                                            <span>{t("Competitor's keywords-{{v1}} website/month, {{v2}} in total", 10, 50)}</span>
                                        </div>
                                        <div className="feature-item">
                                            <div className="checkmark">
                                                <Icon source={CheckOutIcon} tone="base" />
                                            </div>
                                            <span>{t("AMP")}</span>
                                        </div>
                                        <div className="feature-item">
                                            <div className="checkmark">
                                                <Icon source={CheckOutIcon} tone="base" />
                                            </div>
                                            <span>{t("Backlink Audit")}</span>
                                        </div>
                                    </BlockStack>
                                </div>
                                {
                                    level !== 3 && <div className="button-container">
                                        <Button variant='primary' onClick={() => this.jumpPricingPage('month')}>{t("Change plan")}</Button>
                                    </div>
                                }
                            </div>
                        </BlockStack>
                    </Card>
                    {/* <Card>
                        <Text variant="headingMd" as="h2">{t("Account info")}</Text>
                        <div className='flex_set'>
                            <div className='flex_item'>
                                <div className='flex_item_row'>{t("Current plan")}: <Text as="p" fontWeight="bold">{planTitle}</Text> <Button variant='plain' textAlign="left" onClick={() => this.jumpPricingPage('month')}>{level === 3 ? t("Downgrade") : t("Upgrade")}</Button></div>
                                {
                                    level > 1 && <div className='flex_item_row'>{t("Next quota reset date")} :  <Text as="p" fontWeight="bold">{reset_quota}</Text></div>
                                }
                            </div>
                            <div className='flex_item'>
                                <BlockStack gap={300}>
                                    {ImageExceedCardContent}
                                    {ImageComboByCardContent}
                                    {OnPageComboByCardContent}
                                    {OnpageCreditsContent}
                                    {OverChargeAllLimit}
                                    {false && TaskReward}
                                </BlockStack>
                                {capModal}
                            </div>
                        </div>
                    </Card> */}
                    {/* {
                        (level === 3 && (is_capped || isComboUser)) && <Card>
                            <BlockStack gap={400}>
                                <div className='Overcharge'>
                                    <Text variant="headingMd" as="h2">{t("Overcharge")}</Text>
                                    <span>
                                        {overState ? <Badge tone="success">{t("On")}</Badge> : <Badge tone="">{t("Off")}</Badge>}
                                    </span>
                                    <div className='switch_overcharge'>
                                        {loadingSwitchOver && <img className="Loading" src="/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                        <Switch disabled={Boolean(loadingSwitchOver || (!is_capped && !isComboUser))} onChange={this.changeOverState} checked={Boolean(overState)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                    </div>
                                </div>
                                <Text variant="bodyXs" as="p">{t("When the number of compressed images exceeds the quota, whether to allow automatic deduction.")}</Text>
                            </BlockStack>
                        </Card>
                    } */}
                    {
                        (level !== 1 || addoneList.length > 0) && <Card>
                            <BlockStack gap={400}>
                                {
                                    (isOneTrial && isShowOverchargeTip) && <Banner
                                        title={t("By enabling Add-on Overcharge, you confirm that all add-on fees during your trial period are non-refundable.")}
                                        tone='warning'
                                        onDismiss={this.closeOverchargeTip}
                                    ></Banner>
                                }
                                {
                                    // (level === 3 && (is_capped || isComboUser)) && 
                                    <BlockStack>
                                        <div className='Overcharge' id='OverchargeBlock'>
                                            <Text variant="headingMd" as="h2">{t("Overcharge")}</Text>
                                            {/* <span>
                                            {overState ? <Badge tone="success">{t("On")}</Badge> : <Badge tone="">{t("Off")}</Badge>}
                                        </span> */}
                                            <div className='switch_overcharge'>
                                                {loadingSwitchOver && <img className="Loading" src="/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                                <Switch disabled={uid === 64672 || Boolean(loadingSwitchOver || (level === 1 && !is_capped && !isComboUser))} onChange={this.changeOverState} checked={Boolean(overState)} height={20} width={32} uncheckedIcon={true} checkedIcon={true} onColor="#303030" offColor="#888888" />
                                            </div>
                                        </div>
                                        <Text as="p" tone="subdued" variant="bodyMd">{t("When the number of credits exceeds the quota, whether to allow automatic deduction.")}</Text>
                                    </BlockStack>
                                }
                                {OverChargeAllLimit}
                                <BlockStack gap={200}>
                                    {/* <Text variant="headingMd" as="h2">{t("Add-ons history")}</Text> */}
                                    <Card padding={0}>
                                        {
                                            (addLoading || iscacheLoading) ? <div className='table_loading' style={{ padding: '6rem 0' }}>
                                                <Spinner />
                                            </div> :
                                                <ImageAddOnesTable
                                                    addoneList={addoneList}
                                                />
                                        }
                                    </Card>
                                </BlockStack>
                            </BlockStack>
                        </Card>
                    }
                </BlockStack> :
                    selected === "General" ? <BlockStack gap={400}>
                        <Card>
                            <BlockStack gap={200}>
                                <Text variant="headingMd" as="h2">
                                    {t("Select application language")}
                                    {loadingSwitch && <img className="Loading" src="/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                </Text>
                                <Text as="p" color="subdued">{t("Please choose your preferred application language.")}</Text>
                                <Select
                                    options={[
                                        {
                                            value: 'cs',
                                            label: "Čeština",
                                        },
                                        {
                                            value: 'da',
                                            label: "Dansk",
                                        },
                                        {
                                            value: 'ge',
                                            label: "Deutsch",
                                        },
                                        {
                                            value: 'en',
                                            label: "English",
                                        },
                                        {
                                            value: 'sp',
                                            label: "Español",
                                        },
                                        {
                                            value: 'fr',
                                            label: "Française",
                                        },
                                        {
                                            value: 'it',
                                            label: "Italian",
                                        },
                                        {
                                            value: 'in',
                                            label: "India",
                                        },
                                        {
                                            value: 'dut',
                                            label: "Nederlands",
                                        },
                                        {
                                            value: 'nb',
                                            label: "Norsk (bokmål)",
                                        },
                                        {
                                            value: 'pl',
                                            label: "Polski",
                                        },
                                        {
                                            value: 'pt_BR',
                                            label: "Português (Brasil)",
                                        },
                                        {
                                            value: 'pt',
                                            label: "Português (Portugal)",
                                        },
                                        {
                                            value: 'fi',
                                            label: "Suomi",
                                        },
                                        {
                                            value: 'sv',
                                            label: "Svenska",
                                        },
                                        {
                                            value: 'tr',
                                            label: "Türkçe",
                                        },
                                        {
                                            value: 'th',
                                            label: "ภาษาไทย",
                                        },
                                        {
                                            value: 'ja',
                                            label: "日本語",
                                        },
                                        {
                                            value: 'zh_hant',
                                            label: "中文繁体",
                                        },
                                        {
                                            value: 'zh',
                                            label: "中文简体",
                                        },
                                        {
                                            value: 'ko',
                                            label: "한국어",
                                        },
                                    ]}
                                    disabled={loadingSwitch || iscacheLoading}
                                    value={Boolean(_info) ? _info : Language}
                                    onChange={this.changeLanguage}
                                />
                            </BlockStack>
                        </Card>
                        {
                            isShowCwAdverSetting &&
                            <Card>
                                <div className='cw_setting_adver cw_adver'>
                                    <img src='/extra_app/langwill_cw.png' />
                                    <span onClick={this.closeSettingCwAdver}><Icon source={CancelMajor} tone="base" /></span>
                                    <p>
                                        Translate your store with&nbsp;<Button variant='plain' onClick={() => {
                                            window.open("https://share.channelwill.com/app/16149dc9d5c9whK150")
                                        }}>{t("Langwill")}</Button>&nbsp;to boost your multilingual SEO performance.
                                    </p>
                                </div>
                                <div className='cw_setting_btn'>
                                    <Button onClick={() => {
                                        window.open("https://share.channelwill.com/app/16149dc9d5c9whK150")
                                    }}>{t("Try Langwill Free")}</Button>
                                </div>
                            </Card>
                        }
                        <Card>
                            <Text variant="headingMd" as="h2">{t("Affiliate program")}</Text>
                            <div className='Affiliate_help'>
                                <ul>
                                    <li>{t("Earn 30% commission of every payment")}</li>
                                    <li>{t("Offer your friends a 30% discount")}</li>
                                    <li>{t("Easily track your affiliate performance with a smart dashboard")}</li>
                                    <li>{t("Just copy your unique referral link and start to promote SEOAnt")}</li>
                                    <li>{t("The referral store has never installed SEOAnt APP before.")}</li>
                                </ul>
                                <div className='Affiliate_action'>
                                    <Button onClick={() => {
                                        window.open(ap_login_url);
                                    }}>{t("Your affiliate account")}</Button>
                                    <div className='Affiliate_action_item'>
                                        <Text as="p" fontWeight="medium">{t("Share with")}: </Text>
                                        &nbsp;
                                        <Tooltip content={<span style={{ color: '#005bd3' }}>{short_url}</span>}>
                                            <Button variant='plain' textAlign="left" onClick={() => this.openLinkAffiliate(short_url)}>{t("link")}</Button>
                                        </Tooltip> /
                                        <Button variant='plain' textAlign="left" onClick={() => this.openAppAction('facebook')}>{t("Facebook")}</Button> /
                                        <a className='email' href={"mailto:?subject=I think you'll like SEOAnt - SEO %26 Image Optimizer 😘&body=    I wanted to share with you a great tool that has helped me optimize my store's SEO - SEOAnt. This app has been a game changer for me as it has saved me time and improved my site's rankings through bulk optimization of meta tags, images, and automatic redirection of broken links. With SEOAnt, I can focus on creating great content, and its AI Writing feature has even given me ideas for content creation that have increased my traffic.%0d%0a    I highly recommend giving SEOAnt a try. If you use the following link, you can even get 30% discount for all plan: " + short_url + "%0d%0a    Thank you and regards."} target="_top">{t("Email")}</a>
                                    </div>
                                </div>
                            </div>
                        </Card>
                        <Card>
                            <BlockStack gap={200}>
                                <div className='flex_layout remove_setting'>
                                    <Text variant="headingMd" as="h2">
                                        {t("Remove seogidXXX")}
                                        {
                                            isRemoveState ? <Badge tone='success'>{t("On")}</Badge> :
                                                <Badge>{t("Off")}</Badge>
                                        }
                                    </Text>
                                    <div className='flex_layout' style={{ columnGap: 0 }}>
                                        {(removeLoading || iscacheLoading) && <img className="Loading" src="/Image/loading.gif" style={{ width: '1.2rem', margin: '0 0.4rem' }} alt="loading" />}
                                        <Switch disabled={Boolean(removeLoading || iscacheLoading)} onChange={() => this.handleCheckChange('isRemoveState')} checked={Boolean(isRemoveState)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                                    </div>
                                </div>
                                <div className='link-tip'>https://www.seoant.com/<span className='high_params'>#seogid1234356</span></div>
                                <Text as="p" color="subdued">{t("When enabled, the seogidXXX characters in redirected links and redundant codes in page extensions will be removed.")}</Text>
                                <Text as="p" color="subdued">{t("It will not affect the normal inclusion of 404 links, but the number of visits to the links will not be counted later.")}</Text>
                            </BlockStack>
                        </Card>
                    </BlockStack> :
                        selected === "Notifications" ? <BlockStack gap={400}>
                            {/* {
                                (setTabKey === 1) && shopifyMode ? <div style={{ textAlign: 'right' }}>
                                    <Button
                                        variant='primary'
                                        disabled={saveDisabled[(setTabKey === 0) ? 0 : (setTabKey === 1) ? 1 : 2]}
                                        loading={saveLoading[(setTabKey === 0) ? 0 : (setTabKey === 1) ? 1 : 2]}
                                        onClick={() => this.saveDataInfo()}
                                    >{t("Save")}</Button>
                                </div> : null
                            } */}
                            <Card>
                                <BlockStack gap={200}>
                                    <div className='flex_layout_betw'>
                                        <Text variant="headingMd" as="h2">{t("404 Pages report")}</Text>
                                        <div className='flex_layout' style={{ columnGap: 0 }}>
                                            <Switch disabled={Boolean(iscacheLoading)} onChange={() => this.handleCheckChange('broChecked')} checked={Boolean(broChecked)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                                        </div>
                                    </div>
                                    <p>{t("Notify me when 404 pages detected")}</p>
                                    {/* <Checkbox
                                        label={t("Notify me when 404 pages detected")}
                                        checked={broChecked}
                                        onChange={() => this.handleCheckChange('broChecked')}
                                    /> */}
                                    <div className='fzf_set flex_layout'>
                                        <TextField
                                            label={t("Email")}
                                            value={eamilBro}
                                            onChange={(val) => this.handleEamilChange(val, 'eamilBro')}
                                            // disabled={!Boolean(broChecked)}
                                            placeholder='info@shava.co'
                                            autoComplete="off"
                                            error={emailError}
                                            prefix={<Icon source={EmailMajor} tone='base' />}
                                        />
                                        <Select
                                            label={t("Report Frequency")}
                                            options={[
                                                { label: t("Daily"), value: 1 },
                                                { label: t("Weekly"), value: 2 },
                                                { label: t("Monthly"), value: 3 }
                                            ]}
                                            onChange={this.selectReportItem}
                                            value={frequency}
                                        />
                                    </div>
                                </BlockStack>
                            </Card>
                            <Card>
                                <BlockStack gap={200}>
                                    <div className='flex_layout_betw'>
                                        <Text variant="headingMd" as="h2">{t("Exchange backlinks notification")}</Text>
                                        <div className='flex_layout' style={{ columnGap: 0 }}>
                                            <Switch disabled={Boolean(iscacheLoading)} onChange={() => this.handleCheckChange('exchangeChecked')} checked={Boolean(exchangeChecked)} height={20} width={32} uncheckedIcon={false} checkedIcon={false} onColor="#303030" offColor="#888888" />
                                        </div>
                                    </div>
                                    <p>{t("Notify me when someone requests a link exchange with me")}</p>
                                    {
                                        NotOpenBacklink && <Banner
                                            title={t("Please enable the external link exchange function first!")}
                                            tone="warning"
                                            onDismiss={() => {
                                                this.setState({ NotOpenBacklink: false })
                                            }}
                                            action={{
                                                content: t("Contact us"),
                                                onAction: this.handleContactService
                                            }}
                                        >
                                        </Banner>
                                    }
                                    {/* <div className='set_email_block'>
                                        <Checkbox
                                            label={t("Notify me when someone requests a link exchange with me")}
                                            checked={exchangeChecked}
                                            onChange={() => this.handleCheckChange('exchangeChecked')}
                                        />
                                    </div> */}
                                    <TextField
                                        label={t("Email")}
                                        value={eamilUser}
                                        // disabled={!Boolean(exchangeChecked)}
                                        onChange={(val) => this.handleEamilChange(val, 'eamilUser')}
                                        placeholder='info@shava.co'
                                        autoComplete="off"
                                        error={backlinkError}
                                        prefix={<Icon source={EmailMajor} tone='base' />}
                                    />
                                </BlockStack>
                            </Card>
                        </BlockStack> :
                            selected === "Integration" ? <BlockStack gap={400}>
                                <FunctionIntegration language={window.language} toggleToast={this.props.toggleToast} />
                                <div>
                                    <Tabs tabs={[
                                        {
                                            id: "Recommended-1",
                                            content: t("By channelwill"),
                                        },
                                        {
                                            id: "Recommended-2",
                                            content: t("By SEOAnt"),
                                        },
                                    ]} selected={interSelect} onSelect={this.handleInterTabChange}></Tabs>
                                    {
                                        interSelect === 0 ? <SloutionExpert domain={domain} /> : SEOAntBlock
                                    }
                                </div>
                            </BlockStack> :
                                selected === "SiteVerifications" ? <>
                                    <SiteVerify
                                        setShowSaveBarState={this.setShowSaveBarState}
                                        setSaveState={this.setSaveState}
                                        toggleToast={this.props.toggleToast}
                                    />
                                </> : null
            }
        </div>

        // 底部
        const FooterHelpBox = <FooterTrustHelp />

        // 最终页面
        const pageContent = !loadingPage ? <div className='Settings_page'>
            <Page
                // fullWidth
                title={shopifyMode ? t("Settings") : ''}
            // primaryAction={(setTabKey === 1) && shopifyMode ? {
            //     content: 'Save',
            //     disabled: saveDisabled[(setTabKey === 0) ? 0 : (setTabKey === 1) ? 1 : 2],
            //     loading: saveLoading[(setTabKey === 0) ? 0 : (setTabKey === 1) ? 1 : 2],
            //     onAction: () => this.saveDataInfo()
            // } : null}
            >
                <title>SEOAnt - Settings</title>
                <SaveBarTop
                    isShowSaveBar={isShowSaveBar}
                    saveLoading={saveLoading[1]}
                    handleSaveAction={this.saveDataInfo}
                    handleDiscardAction={this.handleDiscardAction}
                />
                {/* <div className='set_split' style={{ columnGap: (setTabKey === 4) ? '0' : '1.5em' }}>
                    <Tabs
                        tabs={[
                            { id: "Account-1", value: "Account", content: t("Account") },
                            { id: "Notifications-2", value: "Notifications", content: t("Notifications") },
                            { id: "Integration-3", value: "Integration", content: t("Integration") },
                            { id: "SiteVerifications-4", value: "SiteVerifications", content: t("Site Verifications") },
                            { id: "Solutionexpert-5", value: "Solutionexpert", content: t("Solution expert") },
                        ]}
                        selected={setTabKey}
                        onSelect={this.handleTabsSel}
                    ></Tabs>
                    {setTabKey !== 4 && rightContent}
                </div> */}
                <div className='set_Select'>
                    {leftChoice}
                    {setTabKey !== 4 && rightContent}
                </div>

                {/* 底部 */}
                {setTabKey !== 4 && FooterHelpBox}
            </Page>
            {
                setTabKey === 4 && <div className='cw_app_iframe'>
                    <Page
                        fullWidth
                    >
                        {rightContent}
                        {/* 底部 */}
                        {/* {FooterHelpBox} */}
                    </Page>
                </div>
            }
        </div> : <SkeltonLoading />


        return pageContent;
    }
}

// 时间格式
function formatTimestamp(timestamp) {
    const date = new Date(timestamp);
    const options = {
        year: 'numeric',
        month: 'short',
        day: 'numeric',
        timeZone: 'Asia/Shanghai', // 指定中国时区
    };
    const formatted = date.toLocaleDateString('en-US', options);
    return formatted;
}

const mapStateToProps = state => {
    return state
}

const mapDispatchToProps = dispatch => ({
    // 判断是否页面第一次loading
    getPageDataRedux(data) {
        dispatch(setPageData(['settingAcount', data]));
    },

    // 修改语言状态
    changeLanguageStatus(val) {
        dispatch(changeLanguageInfo(val));
    },

    // 是否设置了滚动条
    setScrollHidden(val) {
        dispatch(setScrollHiddenState(val));
    },

    // 设置自定义缓存
    setSwitchData(data) {
        dispatch(setSaveSwitchData(data))
    },
})


Settings = connect(
    mapStateToProps,
    mapDispatchToProps
)(Settings);

export default withRouter(Settings);